module.exports = __webpack_public_path__ + "static/media/janelas.bc56c4b3.svg";